import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react.js';
import TableActions from 'portaltransparencia-common/components/TableActions.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';
import { withRouter } from 'react-router';

const CONFIG_LISTAGEM = {
  despesa: {
    labelValor: 'Valor Repassado',
    labelRestante: 'Valor a Repassar'
  },
  receita: {
    labelValor: 'Valor Recebido',
    labelRestante: 'Valor a Receber'
  }
};

const getConfigCampos = (tipoRepasse, isIntegradoOxy) => {
  if (tipoRepasse === 'despesa') {
    return {
      previsto: isIntegradoOxy
        ? 'valorPrevistoReceber'
        : 'valorPrevistoRepassar',
      devolvido: isIntegradoOxy ? 'valorRecebido' : 'valorDevolvido',
      restante: isIntegradoOxy
        ? 'valorRestanteReceber'
        : 'valorRestanteRepassar'
    };
  }
  return {
    previsto: 'valorPrevistoReceber',
    devolvido: 'valorDevolvido',
    restante: 'valorRestanteReceber'
  };
};

export class RepasseListagem extends Component {
  static propTypes = {
    repasses: PropTypes.object.isRequired,
    tipoRepasse: PropTypes.oneOf(['despesa', 'receita']).isRequired,
    mesInicial: PropTypes.string,
    mesFinal: PropTypes.string,
    history: PropTypes.object.isRequired,
    isIntegradoOxy: PropTypes.string
  };

  renderRepasses = data => {
    const { tipoRepasse, isIntegradoOxy } = this.props;
    const config = getConfigCampos(tipoRepasse, isIntegradoOxy);

    const key =
      data.get('entidade') +
      '_' +
      data.get('exercicio') +
      '_' +
      data.get('conta') +
      '_' +
      data.get('idContaCorrente');

    return (
      <TableActions key={key} data={data} onMore={this.onViewDetalhes}>
        <td>{data.get('nomeFornecedor')} </td>
        <td style={{ textAlign: 'right' }}>
          <NumberFormatter value={data.get(config.previsto)} />
        </td>
        <td style={{ textAlign: 'right' }}>
          <NumberFormatter value={data.get('valorLancado')} />
        </td>
        <td style={{ textAlign: 'right' }}>
          <NumberFormatter value={data.get(config.devolvido)} />
        </td>
        <td style={{ textAlign: 'right' }}>
          <NumberFormatter value={data.get(config.restante)} />
        </td>
      </TableActions>
    );
  };

  onViewDetalhes = item => {
    const { mesInicial, mesFinal, history } = this.props;
    const entidade = item.get('entidade');
    const entidadeDestinoOrigem = item.get('entidadeDestinoOrigem');
    const exercicio = item.get('exercicio');
    const conta = item.get('conta');
    const idContaCorrente = item.get('idContaCorrente');
    const tipo = item.get('tipo');
    const url = `/detalhes?entidade=${entidade}&entidadeDestinoOrigem=${entidadeDestinoOrigem}&exercicio=${exercicio}${
      conta ? `&conta=${conta}` : ''
    }${
      idContaCorrente ? `&idContaCorrente=${idContaCorrente}` : ''
    }&tipo=${tipo}${mesInicial ? `&mesInicial=${mesInicial}` : ''}${
      mesFinal ? `&mesFinal=${mesFinal}` : ''
    }`;
    if (tipo == 'E') {
      history.push(`/repasses-despesa${url}`);
    } else if (tipo == 'R') {
      history.push(`/repasses-receita${url}`);
    }
  };

  render() {
    const { repasses, tipoRepasse } = this.props;
    const config = CONFIG_LISTAGEM[tipoRepasse];

    return (
      <div className="panel-table-outer">
        <table className="panel-table striped fancy">
          <TableHeader empty={repasses.isEmpty()}>
            <tr>
              <th>Órgão</th>
              <th style={{ textAlign: 'right' }}>Valor Previsto</th>
              <th style={{ textAlign: 'right' }}>{config.labelValor}</th>
              <th style={{ textAlign: 'right' }}>Valor Devolvido</th>
              <th style={{ textAlign: 'right' }}>{config.labelRestante}</th>
              <th style={{ width: 10 }}></th>
            </tr>
          </TableHeader>
          <tbody>{repasses.map(this.renderRepasses)}</tbody>
        </table>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isIntegradoOxy: state.entidade.getIn([
      'configuracoesGerais',
      'isIntegradoOxy'
    ])
  };
}

export default withRouter(RepasseListagem);
